module.exports = __webpack_public_path__ + "media/images/login-bkg-77eff0e8103c141eb962c0eb8794325e.png";